export default "__VITE_ASSET__ZtjqZWLW__"